import {makeStyles} from '@material-ui/core';
import React from 'react';
import {rieltor} from 'styles/theme';
import {useBadgeDismiss} from "../../hooks/useBadgeDismiss";

interface BadgeProps {
  value: string | number;
  url: string;
}

const useBadgeDismissStyles = makeStyles(() => ({
  badge: {
    borderRadius: '12px',
    fontFamily: rieltor.fontFamily,
    backgroundColor: rieltor.purple,
    padding: '0 8px',
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: '20px',
    color: '#fff',

    '&.new': {
      fontSize: '12px',
      backgroundColor: rieltor.yellow,
      color: '#000',
    },
  },
}));

// Backend decide where NEW label appears (UserMeta class), and update DB if route visited.
// LocalStorage sync with backend values for smooth updates
export const BadgeDismiss = ({value, url}: BadgeProps) => {
  const classes = useBadgeDismissStyles();
  const {isShowBadge, markAsVisited} = useBadgeDismiss();

  if (!isShowBadge(url)) {
    return null;
  }

  markAsVisited(url);

  if (value === undefined) {
    return null;
  }

  return (
    <div className={`${classes.badge} new`}>{value}</div>
  );
};
